const translations = {
  "en": {
    "Continue with email": "Continue with email",
    "Sign up or log in": "Sign up or log in"
  },
  "zh-tw": {
    "Continue with email": "以電子郵件繼續",
    "Sign up or log in": "註冊或登入"
  }
};

export default translations;
